import ListWorkspacesComponent from "@/components/workspaces/list-workspaces";

export default function ListWorkspaces() {
  return <ListWorkspacesComponent />;
}
